let proving = {
  /*手机号严证*/
  validateMobilePhone(rule, value, callback) {
    if (value === '') {
      callback(new Error('手机号不可为空'));
    } else {
      if (value !== '') {
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error('请输入有效手机号码'));
        }
      }
      callback();
    }
  },
  /*固定电话严证*/
  validatePhone(rule, value, callback) {
    if (value === '') {
      callback(new Error('机构电话不可为空'));
    } else {
      if (value !== '') {
        var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的座机号格式为：0000-0000000'));
        }
      }
      callback();
    }
  },
  /*邮箱严证*/
  validateEmail(rule, value, callback) {
    if (value === '') {
      callback(new Error('请正确填写邮箱'));
    } else {
      if (value !== '') {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(value)) {
          callback(new Error('请输入有效的邮箱'));
        }
      }
      callback();
    }
  },
  /* 密码登录严证*/
  validatePassword(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入正确格式密码'));
    } else {
      if (value !== '') {
        var regex = new RegExp(
          '^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-ZW_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-zW_!@#$%^&*`~()-+=]+$)(?![0-9W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9W_!@#$%^&*`~()-+=]{8,30}$',
        );
        if (!regex.test(value)) {
          callback(
            new Error(
              '请输入数字，大写字母，小写字母，特殊字符四选三组成的密码强度，且长度在8到30个数之间密码',
            ),
          );
        }
      }
      callback();
    }
  },
  /* 支付密码严证*/
  validatePayPassword(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入正确格式密码'));
    } else {
      if (value !== '') {
        var regex = new RegExp('^\\d{6}$');
        if (!regex.test(value)) {
          callback(new Error('请输入6位数字的支付密码'));
        }
      }
      callback();
    }
  },
};
export default proving;
